// extracted by mini-css-extract-plugin
export default {"rowMetodoPago":"informacionDePago_rowMetodoPago__Hy27S","col1":"informacionDePago_col1__9HqLC","col2":"informacionDePago_col2__TQhW0"};